import "./Hero.css";
import DemoRequestForm from "../DemoRequestForm/DemoRequestForm";

export default function Hero() {
  return (
    <div className="hero-page" id="hero">
      <div className="hero-splash" aria-hidden="true">
        {/* <div className="hero-splash-blob hero-splash-blob-a" /> */}
        {/* <div className="hero-splash-blob hero-splash-blob-b" /> */}
        {/* <div className="hero-splash-blob hero-splash-blob-c" /> */}
        <div className="hero-splash-glass" />
      </div>
      {/* <div className="hero-splash hero-splash-right" aria-hidden="true">
        <div className="hero-splash-blob hero-splash-blob-d" />
        <div className="hero-cube-scene">
          <div className="hero-cube">
            <div className="hero-cube-face hero-cube-face-top" />
            <div className="hero-cube-face hero-cube-face-bottom" />
            <div className="hero-cube-face hero-cube-face-left" />
            <div className="hero-cube-face hero-cube-face-right" />
            <div className="hero-cube-face hero-cube-face-front" />
            <div className="hero-cube-face hero-cube-face-back" />
          </div>
        </div>
      </div> */}
      <div className="hero-noise" aria-hidden="true" />



      <main className="hero-main">
        <section className="hero-copy">
          <a href="https://www.smushlabs.ai/blog/premier-tefl-case-study" className="hero-announcement">
            <span>NEW</span>
            <em>How Premier TEFL Automated 70% of Student Support →</em>
          </a>

          <h1>Conversational agents for customer experience</h1>

          <p className="hero-description">
            Resolve support requests faster, assist customers 24/7, and <span>deliver consistent help with an all-in-one AI support platform.</span>
          </p>

          <div className="hero-capture-shell">
            <DemoRequestForm source="hero" buttonText="Request free demo" />
          </div>

          <a
            className="hero-badge hero-badge-under-form"
            href="https://peerpush.net/p/smushchat-ai-chatbot-agent-builder"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://peerpush.net/p/smushchat-ai-chatbot-agent-builder/badge.png"
              alt="SmushChat AI Chatbot Agent Builder badge"
            />
          </a>
        </section>
      </main>
    </div>
  );
}
